// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"bf9070c4","850":"5751e5b7"}[chunkId] + ".chunk.js";
};